import { ApiConfig } from "../api/apiConfig/apiConfig";

/**
 * Backend may return paths like "apk/foo.apk" — prefix with ApiConfig.baseUrl (same host as API).
 */
function resolveBackendAssetUrl(raw) {
  if (raw == null || typeof raw !== "string") return null;
  const s = raw.trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const base = String(ApiConfig.baseUrl || "").replace(/\/+$/, "");
  const path = s.replace(/^\/+/, "");
  if (!base) return s.startsWith("/") ? s : `/${path}`;
  return `${base}/${path}`;
}

/**
 * Normalizes getApk API responses for header download UI.
 * Supports string data, or objects with common key names from backends.
 */
export function parseGetApkResponse(res) {
  if (!res || typeof res !== "object") return null;
  if (res.success === false && res.data == null) return null;

  let d = res.data !== undefined ? res.data : null;
  if (d == null && (res.apkUrl || res.url || res.androidUrl || res.apk)) {
    d = res;
  }
  if (d == null) return null;

  if (typeof d === "string") {
    const s = d.trim();
    if (/^https?:\/\//i.test(s)) return { androidUrl: s, iosUrl: null, qrUrl: null };
    const resolved = resolveBackendAssetUrl(s);
    if (resolved) return { androidUrl: resolved, iosUrl: null, qrUrl: null };
    return null;
  }

  if (typeof d !== "object" || Array.isArray(d)) return null;

  const androidUrl =
    d.apkUrl ||
    d.androidUrl ||
    d.android_url ||
    d.androidApk ||
    (typeof d.android === "string" ? d.android : null) ||
    d.url ||
    d.downloadUrl ||
    d.download_url ||
    d.link ||
    (typeof d.apk === "string" ? d.apk : null);

  const iosUrl =
    d.iosUrl ||
    d.ios_url ||
    (typeof d.ios === "string" ? d.ios : null) ||
    d.appStoreUrl ||
    d.app_store_url ||
    d.iphoneUrl;

  const qrUrl =
    d.qrCode ||
    d.qr_code ||
    d.qr ||
    d.qrUrl ||
    d.qrcode ||
    d.qr_image ||
    (typeof d.image === "string" && /^https?:\/\//i.test(d.image) ? d.image : null);

  if (!androidUrl && !iosUrl && !qrUrl) return null;
  return {
    androidUrl: resolveBackendAssetUrl(androidUrl) || null,
    iosUrl: resolveBackendAssetUrl(iosUrl) || null,
    qrUrl: resolveBackendAssetUrl(qrUrl) || qrUrl || null,
  };
}
